import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BasicPopupComponent } from '../popup/basic-popup.component';

@Component({
  selector: 'common-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.scss'],
  standalone: false,
})
export class PaymentPopupComponent {
  @Input() headerText: string =
    $localize`:@@wallet.enter-card-details:Enter your credit card details`;
  @Input() onSuccess: any;
  @Input() showTopupButton: boolean;
  @Input() showRedirectButton: boolean;
  @Output() onOkClick = new EventEmitter<boolean>();
  @Input() onCancel: any;
  @Input() isLoading: boolean = true;

  constructor(
    private readonly modalService: NgbModal,
    private readonly cdr: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    setTimeout(() => {
      this.isLoading = false;
      this.cdr.detectChanges();
    }, 3000);
  }
  closeModal() {
    this.openDialog();
  }

  public openDialog(): void {
    const options: NgbModalOptions = {
        windowClass: 'basic-modal',
        backdrop: 'static',
        keyboard: false,
        centered: true,
      },
      dialogRef = this.modalService.open(BasicPopupComponent, options);
    dialogRef.componentInstance.header = $localize`:@@global.are-you-sure-you-want-to-cancel:ARE YOU SURE YOU WANT TO CANCEL?`;
    dialogRef.componentInstance.body =
      '<span>If Yes, your transaction will be lost.</span>';
    dialogRef.componentInstance.primaryButtonText = $localize`:@@yes-cancel:Yes, cancel`;
    dialogRef.componentInstance.primaryButtonColor = '#32CB8C';
    dialogRef.componentInstance.secondaryButtonColor = '#FF4453';
    dialogRef.componentInstance.titleColor = '#53A8E7';
    dialogRef.componentInstance.closeButtonColor = '#53A8E7';

    dialogRef.result.then(
      () => {},
      () => {
        this.modalService.dismissAll();
        if (this.onCancel) {
          this.onCancel();
        }
      },
    );
  }
  topUpBalance(): void {
    if (this.onSuccess) {
      this.onSuccess();
    }
  }

  redirectUser(): void {
    this.onOkClick.emit(true);
  }
}
